export enum ScenarioModel {
  /**
   * Effective Energy Gt2, sea-based salmon on-growing.
   */
  EFFECTIVE_ENERGY_GT_2 = 'effectiveEnergyGt2',
  EFFECTIVE_ENERGY_GT_2_MULTI = 'effectiveEnergyGt2Multi',
}
